import { GetActivitiesType, AddActivityNoteType } from "./types";

export const getActivitiesSlr = (state: any): GetActivitiesType => state.fundDetails.account.activity.getActivities;
export const addActivityNoteSlr = (state: any): AddActivityNoteType =>
	state.fundDetails.account.activity.addActivityNote;
